import { IconLibrary } from "../../../interfaces/icon/IconLibrary";
import { FormElementType } from "../interfaces/IFormElement";

export function getFormElementIconName(elementType: FormElementType) {
    switch (elementType) {
        case FormElementType.SHORT_TEXT:
            return IconLibrary.DASH;
        case FormElementType.LONG_TEXT:
            return IconLibrary.PARAGRAPH;
        case FormElementType.DROPDOWN:
            return IconLibrary.INPUT_DOTS;
        case FormElementType.USER_SELECT:
            return IconLibrary.USER_SEARCH;
        case FormElementType.CHECKBOX:
            return IconLibrary.CHECKBOX;
        case FormElementType.IMAGE_SELECT:
            return IconLibrary.IMAGE;
        case FormElementType.VIDEO_SELECT:
            return IconLibrary.VIDEO;
        case FormElementType.FILE_SELECT:
            return IconLibrary.FILE_UPLOAD;
        case FormElementType.SUBMIT_BUTTON:
            return IconLibrary.DASH;
        case FormElementType.CHOICE_BUTTON:
            return IconLibrary.CHOICE_PILL;
        default:
            return IconLibrary.DASH;
    }
}